import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction'
import PersonIcon from '@mui/icons-material/Person'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'
import { List, ListItem, ListItemButton, ListItemIcon, Tooltip, Typography, useTheme } from '@mui/material'

const BoardsNavigation = ({
  handleNavigation,
  selectedPath,
  isLoading,
  horizontal: _horizontal,
}: {
  handleNavigation: any
  selectedPath: any
  isLoading: any
  horizontal?: boolean
}) => {
  const theme = useTheme()

  const navItems = [
    {
      label: 'Leads',
      path: 'leads',
      color: 'rgb(94, 123, 167)',
      icon: <OnlinePredictionIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Approvals',
      path: 'approvals',
      color: theme.palette.mode === 'dark' ? 'rgba(205, 254, 194, 1)' : 'rgb(159, 206, 149)',
      icon: <PublishedWithChangesIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Organizations',
      path: 'organizations',
      color: 'rgb(114, 229, 218)',
      icon: <CorporateFareIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Deals',
      path: 'deals',
      color: '#fbc11e',
      icon: <AttachMoneyIcon sx={{ height: 22, width: 22 }} />,
    },
    {
      label: 'Contacts',
      path: 'contacts',
      color: 'rgb(255, 123, 187)',
      icon: <PersonIcon sx={{ height: 22, width: 22 }} />,
    },
  ]

  return (
    <List
      disablePadding
      sx={{
        display: 'flex',
        flexDirection: 'row', // force horizontal layout
        alignItems: 'center',
        // remove default list margin/padding if needed
        m: 0,
      }}
    >
      {navItems.map(item => {
        const isSelected = item.path === selectedPath.replace(/^\//, '')

        return (
          <ListItem
            key={item.label}
            disablePadding
            sx={{
              width: 'auto',
              display: 'inline-flex',
            }}
          >
            <ListItemButton
              disableGutters
              sx={{
                flexDirection: 'row',
                minWidth: 50,
                minHeight: 50,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'transparent',
                transition: 'transform 0.2s ease-in-out',
                // Icon styling - default muted, colored when selected or hovered
                '& .MuiSvgIcon-root': {
                  color: isSelected ? item.color : theme.palette.text.primary,
                  transition: 'color 0.2s ease-in-out',
                },
                // Hover on the entire button triggers icon color change
                '&:hover': {
                  backgroundColor: 'transparent',
                  transform: 'scale(1.2)',
                  '& .MuiSvgIcon-root': {
                    color: item.color,
                  },
                },
              }}
              onClick={() => handleNavigation(item.path)}
              disabled={isLoading}
            >
              <Tooltip
                enterDelay={500}
                leaveDelay={0}
                title={<Typography p={1}>{item.label}</Typography>}
                placement="top"
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              </Tooltip>
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}

export default BoardsNavigation
